export default {
	showDialog: (state) => state.showDialog,
	page: (state) => state.page,
	errorCode: (state) => state.errorCode,
	message: (state) => state.message,

	successDialog: (state) => state.successDialog,
};
